export default __webpack_public_path__ + "static/media/twitter_black.8fcbd234.svg";